import { useState } from "react";
import { Link } from "react-router-dom";
import { requestAdminPasswordReset } from "../../features/adminAuth/adminAuthStorage";

const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setSubmitting(true);

    const result = await requestAdminPasswordReset({ email });
    if (!result.ok) {
      setError(result.message);
      setSubmitting(false);
      return;
    }

    setSuccess(result.message || "If this admin email exists, a reset link has been sent.");
    setSubmitting(false);
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <h1>Forgot Admin Password</h1>
        <p>Enter your admin email and we will send a secure reset link.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="adminForgotEmail">Email</label>
          <input
            id="adminForgotEmail"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="admin@verixxon.com"
            required
          />

          {error ? <p className="auth-error">{error}</p> : null}
          {success ? <p className="auth-success">{success}</p> : null}

          <button type="submit" disabled={submitting}>
            {submitting ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="auth-switch">
          Back to <Link to="/admin/login">Admin login</Link>
        </p>
      </section>
    </main>
  );
};

export default AdminForgotPasswordPage;
